import { apiClient } from "./client";

export type ApplicationStatus =
  | "PENDING"
  | "APPROVED"
  | "REJECTED"
  | "CANCELLED";

export type ApplicationOut = {
  id: string;
  last_name: string;
  first_name: string | null;
  rpps: string | null;
  birth_date: string | null;
  email: string;
  phone: string | null;
  message: string | null;
  organization_code: string;
  organization_id: string | null;
  tenant_id: string | null;
  status: ApplicationStatus;
  decided_at: string | null;
  decided_by_user_id: string | null;
  decision_reason: string | null;
  created_practitioner_id: string | null;
  created_user_id: string | null;
  created_at: string;
  updated_at: string;
};

export type ApplyPayload = {
  last_name: string;
  first_name?: string;
  rpps?: string;
  birth_date?: string;
  email: string;
  phone?: string;
  organization_code: string;
  message?: string;
};

export type ApproveOptions = {
  create_user_invite?: boolean;
  membership_kind?: "SALARIE" | "LIBERAL" | "VACATAIRE" | "STAGIAIRE" | "RESERVISTE";
  note?: string;
};

export async function submitApplication(payload: ApplyPayload): Promise<void> {
  await apiClient.post("/api/v1/auth/apply", payload);
}

export async function listApplications(
  status?: ApplicationStatus,
): Promise<{ items: ApplicationOut[]; total: number }> {
  const { data } = await apiClient.get<{ items: ApplicationOut[]; total: number }>(
    "/api/v1/admin/practitioner-applications",
    { params: status ? { status } : undefined },
  );
  return data;
}

export async function approveApplication(
  id: string,
  opts: ApproveOptions = {},
): Promise<ApplicationOut> {
  const { data } = await apiClient.post<ApplicationOut>(
    `/api/v1/admin/practitioner-applications/${id}/approve`,
    {
      create_user_invite: opts.create_user_invite ?? true,
      membership_kind: opts.membership_kind ?? "LIBERAL",
      note: opts.note ?? null,
    },
  );
  return data;
}

export async function rejectApplication(
  id: string,
  reason?: string,
): Promise<ApplicationOut> {
  const { data } = await apiClient.post<ApplicationOut>(
    `/api/v1/admin/practitioner-applications/${id}/reject`,
    { reason: reason ?? null },
  );
  return data;
}
